<template>
  <span>
    <v-dialog v-model="dialog" width="90%">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>{{componentIcon}}</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>{{administrator && administrator.id ? 'Edit Administrator':'New Administrator'}}
          <v-spacer/>
          <v-btn @click="dialog=false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
          <administrator-form ref="adminForm" :locations="locations" :administrator.sync="administrator" />
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="saveOrUpdateAdministrator">{{administrator && administrator.id ? 'Update':'Save'}}</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    administrator: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      required: false
    },
    activatorIcon: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dialog: false,
      componentIcon: 'mdi-pencil',
    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading"])
  },
  components: {
    AdministratorForm: () => import("@/components/AdministratorForm.vue")
  },
  mounted() {
    const icon = this.administrator.id ? 'mdi-pencil':'mdi-plus';
    this.componentIcon = this.activatorIcon ? this.activatorIcon:icon;
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    saveOrUpdateAdministrator() {
      if (!this.$refs.adminForm.$refs.form.validate()) {
        this.addErrorMessage("Please check all required fields are entered");
        return;
      }

      const postData = Object.assign({}, this.administrator);
      if(this.administrator && this.administrator.id){
        postData['userId'] = this.administrator.id;
      }

      if(this.administrator.locations){
        postData.locations = this.administrator.locations.map( l => l.id || l );
      }

      this.$axios
        .post("/account/account-provision-user", postData)
        .then(resp => {
          console.log(resp.data);
          this.administrator = resp.data;
          this.$emit('updated', this.administrator);
          this.addSuccessMessage('Administrator updated');
          this.dialog = false
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
  },
};
</script>

<style>
</style>